import { Box } from "@mui/material";
import {
  GRID_AGGREGATION_FUNCTIONS_NO_LABEL,
  HotkeyCompliantDataGrid,
} from "components/common/dataGrid/HotkeyCompliantDataGrid";
import { GridColDef } from "@mui/x-data-grid-premium";
import { ConsumptionProjectionMaterialItemRead } from "src/store/api/generatedApi";
import { usePercentageSerialiser } from "hooks/serialisers/percentages";
import { useTenantTranslation } from "hooks/formatters";
import { useMemo } from "react";

interface ProjectionsGridProps {
  rows: ConsumptionProjectionMaterialItemRead[];
  onProcessRowUpdate: (
    newRow: ConsumptionProjectionMaterialItemRead
  ) => Promise<ConsumptionProjectionMaterialItemRead>;
}

export const ProjectionsGrid = ({
  rows,
  onProcessRowUpdate,
}: ProjectionsGridProps) => {
  const { t } = useTenantTranslation();
  const { format } = usePercentageSerialiser(1);

  const columns: GridColDef<ConsumptionProjectionMaterialItemRead>[] = useMemo(
    () => [
      {
        field: "material_name",
        headerName: t("material"),
        editable: false,
        width: 200,
      },
      {
        field: "quantity",
        headerName: t("projectedConsumption"),
        type: "number",
        width: 200,
        editable: true,
      },
      {
        field: "fraction",
        headerName: t("projectedFraction"),
        type: "number",
        width: 200,
        editable: false,
        valueFormatter: (value) => `${format(value)}%`,
      },
    ],
    [t, format]
  );

  return (
    <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
      <HotkeyCompliantDataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row.material_name}
        processRowUpdate={onProcessRowUpdate}
        aggregationFunctions={GRID_AGGREGATION_FUNCTIONS_NO_LABEL}
        aggregationModel={{
          material_name: "size",
          quantity: "sum",
          fraction: "sum",
        }}
        cellSelection
        disableRowSelectionOnClick
        getCellClassName={() => "data-grid-cell"}
        sx={{
          maxHeight: "100%",
          "& .MuiDataGrid-cell--editing": {
            bgcolor: "background.paper",
            "& .MuiInputBase-root": {
              height: "100%",
            },
          },
          "& .data-grid-cell": {
            cursor: "cell",
          },
        }}
      />
    </Box>
  );
};
